@let typeLabel = presentation().typeLabel | translate;
@let displayLabel = showDisplayType() && presentation().displayLabel ? (presentation().displayLabel | translate) : "";
<span class="indicator" [title]="typeLabel + (displayLabel ? ' · ' + displayLabel : '')">
    @if (showIcon()) {
        <mat-icon class="material-symbols-outlined indicator__icon" aria-hidden="true">
            {{ presentation().icon }}
        </mat-icon>
    }
    <span class="indicator__label">
        <span>{{ typeLabel }}</span>
        @if (displayLabel && displayLabel !== typeLabel) {
            <span class="indicator__display">
                <span class="indicator__separator m-l-xs" aria-hidden="true">·</span>
                {{ displayLabel }}
            </span>
        }
    </span>
</span>
